import { NgFor } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MatLegacyCheckboxModule as MatCheckboxModule,
  MatLegacyCheckboxChange,
} from '@angular/material/legacy-checkbox';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatRadioChange } from '@angular/material/radio';
import { CuttingMaterial, CuttingPanel } from 'cloud-shared-lib';
import { Observable } from 'rxjs';

export class ConflictedItems {
  material: CuttingMaterial;
  panels: CuttingPanel[] = [];
}

export class CopyMaterialsInOrderDialogData {
  historyMaterials: CuttingMaterial[] = [];
  materialsOrder: CuttingMaterial[] = [];
}

@Component({
  selector: 'cutting-copy-materials-in-order-dialog',
  templateUrl: './copy-materials-in-order-dialog.component.html',
  standalone: true,
  imports: [
    NgFor,
    MatIconModule,
    MatDialogModule,
    MatRadioModule,
    MatButtonModule,
    MatCheckboxModule,
    MatListModule,
    MatTooltipModule,
    MatLegacySnackBarModule,
  ],
})
export class CopyMaterialsInOrderDialogComponent implements OnInit {
  newMaterials: CuttingMaterial[] = [];
  conflictedItems: ConflictedItems[] = [];

  materials$: Observable<CuttingMaterial[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: CopyMaterialsInOrderDialogData,
    public dialogRef: MatDialogRef<CopyMaterialsInOrderDialogComponent>,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.dialogData.materialsOrder.map(m => {
      const conflictMaterial = this.dialogData.historyMaterials.find(
        element => element.inMaterialBaseId == m.inMaterialBaseId
      );
      if (conflictMaterial) {
        this.conflictedItems.push({ material: conflictMaterial, panels: [] });
      }
    });
  }

  materialRadioGroupChange(item: CuttingMaterial, event: MatRadioChange): void {
    if (event.value === 1) {
      const index = this.newMaterials.findIndex(m => m.inMaterialBaseId == item.inMaterialBaseId);
      if (index !== -1) {
        this.newMaterials[index] = this.dialogData.historyMaterials.find(
          m => m.inMaterialBaseId == item.inMaterialBaseId
        );
      } else {
        this.newMaterials.push(this.dialogData.historyMaterials.find(m => m.inMaterialBaseId == item.inMaterialBaseId));
      }
      this.conflictedItems.find(m => m.material.inMaterialBaseId === item.inMaterialBaseId).panels = [];
    }
    if (event.value === 2) {
      const index = this.newMaterials.findIndex(m => m.inMaterialBaseId == item.inMaterialBaseId);
      if (index === -1) {
        this.newMaterials.push(this.dialogData.historyMaterials.find(m => m.inMaterialBaseId == item.inMaterialBaseId));
      }
      this.checkConflictPanels(item);
    }
  }

  replacePanelChange(event: MatLegacyCheckboxChange, panel: CuttingPanel, material: CuttingMaterial): void {
    if (event.checked) {
      const panelFromHistory = this.dialogData.historyMaterials
        .find(m => m.inMaterialBaseId === material.inMaterialBaseId)
        .panels.find(p => p.position == panel.position);
      const newMaterial = this.newMaterials.find(m => m.inMaterialBaseId === material.inMaterialBaseId);
      const index = newMaterial.panels.findIndex(p => p.position == panel.position);
      if (index !== -1) {
        newMaterial.panels[index] = panelFromHistory;
      }
    } else {
      const panelFromOrder = this.dialogData.materialsOrder
        .find(m => m.inMaterialBaseId === material.inMaterialBaseId)
        .panels.find(p => p.position == panel.position);
      const newMaterial = this.newMaterials.find(m => m.inMaterialBaseId === material.inMaterialBaseId);
      const index = newMaterial.panels.findIndex(p => p.position == panel.position);
      if (index !== -1) {
        newMaterial.panels[index] = panelFromOrder;
      }
    }
  }

  checkConflictPanels(item: CuttingMaterial): void {
    const materialOrder = this.dialogData.materialsOrder.find(m => m.inMaterialBaseId == item.inMaterialBaseId);
    materialOrder.panels.map(p => {
      const conflictPanel = item.panels.find(item => item.position === p.position);
      if (conflictPanel) {
        this.conflictedItems
          .find(c => c.material.inMaterialBaseId == materialOrder.inMaterialBaseId)
          .panels.push(conflictPanel);
      }
    });
  }

  saveAndClose(): void {
    this.dialogData.materialsOrder.map(m => {
      if (!this.newMaterials.find(n => n.inMaterialBaseId == m.inMaterialBaseId)) {
        this.newMaterials.push(m);
      }
    });

    this.snackBar.open('Материалы успешно скопированы');
    this.dialogRef.close(this.newMaterials);
  }
}
